import { RootState } from "store/store";

export const imageUploaderSelector = (state: RootState) => state.imageUploader;
